import i18n from 'i18next';

import { SelectedOption, SelectOption } from 'uikit/selects';

import getTags from '../helpers/getTags';

export default ({ isChildLocale = false }) => ({
  ...(!isChildLocale && {
    tags: {
      type: 'AutoCompleteSearch',
      label: i18n.t('add-tags'),
      help: i18n.t('add-tags-help'),
      handleLoadOptions: getTags,
      CustomSelectedOptionItem: SelectedOption,
      selectProps: {
        components: { Option: SelectOption },
        noOptionsMessage: () => i18n.t('search-tags-empty'),
        placeholder: i18n.t('search-tags'),
      },
    },
  }),
});
